

const autocompleteServices = {};

const noBounds = new window.google.maps.LatLngBounds(
    new window.google.maps.LatLng( 26.0332677,-106.7145229 ),
    new window.google.maps.LatLng( 31.0752616,-101.4152467 )
);

const options = {
    bounds: noBounds,
    types: [ '(regions)' ],
    //Added just US results
    componentRestrictions:{country: 'US'}
};

const AddressAutocomplete = {

    initAutocomplete( inputName, inputField, callback ) {

        autocompleteServices[inputName] = new window.google.maps.places.Autocomplete( inputField, options );

        autocompleteServices[inputName].addListener( 'place_changed', callback.bind( null, autocompleteServices[inputName] ) );

    },

    getCityAndState( addressComponents ) {
        // info to check against
        const componentData = {
            locality: 'long_name',
            sublocality_level_1: 'long_name',
            administrative_area_level_1: 'short_name'
        };
        // create object which will hold information
        const cityAndState = {};
        addressComponents.forEach( component => {
            // console.log( component );
            const componentType = component.types[0];
            if ( componentData[componentType] ) {
                if ( componentType === 'locality' || componentType === 'sublocality_level_1' ) {
                    cityAndState.city = component.long_name;
                } else {
                    cityAndState.state = component.short_name;
                }
            }
        });

        if(cityAndState.city === undefined){
            cityAndState.city = "";
        }
        console.log(cityAndState, "cityAndState");
        // return city and state data
        return cityAndState;
    }
}



export default AddressAutocomplete;



// WEBPACK FOOTER //
// ./src/common/AddressAutocomplete.js